export const hub = {
  back: 'Back',
  activity: 'Activity',
  report: 'Report',
  generate: 'Generate',
  generateFirstReport: 'Generate the first report',
  generateFirstReportBody:
    "See {childName}'s progress summed up in plain language, with what to practise next.",
  generateReport: 'Generate report',
  viewAllReports: 'View all reports',
  homework: 'Homework',
  nothingAssigned: 'Nothing assigned yet',
  viewAllHomework: 'View all homework',
  assignHint: "Assign homework from a report's recommendations, or from Practice.",
  unlink: 'Unlink {childName}',
  reportMeta: '{date} · {accuracy}% accuracy',
  syllabusHeading: 'Syllabus',
  syllabusStudentControlled:
    '{childName} chooses this in their own app, from what your plan covers.',
  syllabusNotSet: 'Not set yet',

  noReports: 'No reports yet',
  noReportsBody: 'Generate the first report from the child hub to see it here.',
  reportListMeta: '{date} · {period} · {accuracy}%',

  allReports: 'All reports',
  allHomework: 'All homework',

  noActivity: 'No activity yet',
  noActivityBody: 'Practice sessions and completed homework will show up here.',
  practiceSession: 'Practice session',
  actFinishedHomework: 'Finished homework: {chapter} · {correct}/{total} correct',
  actPractised: 'Practised {chapter} · {correct}/{total} correct',
  actLeftUnfinished: 'Practised {chapter} · left unfinished',
  showMore: 'Show more',
  activityCapNote: 'Shows the 20 most recent entries',

  reportFallbackTitle: "{childName}'s report",
  downloaded: 'Downloaded',
  downloadPdf: 'Download PDF',
  share: 'Share',

  cancel: 'Cancel',
  generatingSummary: "Generating {childName}'s Summary",
  summaryFallbackName: 'Summary',
  generatingStep0: 'Tupai is analyzing math learning progress...',
  generatingStep1: 'Synthesizing customized recommendations...',
  childNotFound: 'Child not found',
  childNotFoundBody: 'This link may have been removed. Go back to your children list.',
  backToChildren: 'Back to Children',
  couldNotLoadReport: "Couldn't load this report",
  retry: 'Retry',
  refreshNote:
    'Summary refreshes once per day and only when new progress is detected since the last report.',
  toastCooldown: 'You can generate again tomorrow — showing the latest report.',
  toastNoChanges: 'No new activity yet — showing the latest report.',

  homeworkFallbackTitle: 'Homework',
  subLineBase: 'Homework · {studentName}',
  subLineDone: 'Done {date}, {time}',
  subLineStarted: 'Started {date}',
  notStarted: 'Not started yet',
  notStartedBody: "This homework hasn't been started.",
  correctSuffix: 'correct',
  finishedIn: 'finished in {minutes} minutes',
  answered: 'Answered {answer}',
  correctAnswerIs: 'Correct answer {answer}',
  detailUnavailable: 'Detail unavailable',
  allQuestionsListed: 'all {total} questions listed',

  appUsagePeriod: 'App usage · report period',
  appUsageTwoWeeks: 'App usage · past 2 weeks',
  daysOf: '{active} of {total} days',
  studyTime: 'Study time',
  dailyAverage: 'Daily average',
  minsShort: '{mins} min',
  hoursMins: '{hours}h {mins}m',
  minsTooltip: '{mins} mins',
  periodStart: 'Period start',
  periodEnd: 'Period end',
  twoWeeksAgo: '2 weeks ago',
  lastWeek: 'Last week',
  today: 'Today',
  aiInsights: 'Tupai AI Insights',
  keyStrengths: 'Key Strengths',
  areasToFocus: 'Areas to Focus',
  recommendation: 'Recommendation',
  assignedTo: 'Assigned to {studentName} · {date}',

  sampleReportTitle1: 'A strong week in Fractions',
  sampleReportTitle2: 'Percentages need attention',
  sampleReportTitle3: 'Steady progress in Ratios',
  sampleReportTitle4: 'Back into a routine',
  sampleReportTitle5: 'First week of practice',
  sampleReportOverview:
    '{childName} practised on 5 of 7 days and got 78% of questions right. Fractions is now her strongest chapter. Percentages still trip her up, mostly when a question asks for a percentage change.',
  sampleReportStrength1: 'Fractions: 22 of 24 correct this week, her best chapter yet.',
  sampleReportStrength2: 'Practised on 5 of 7 days, a steady habit.',
  sampleReportImprovement1:
    'Percentages: 9 of 16 correct. She mixes up "percentage of" with "percentage change".',
} as const;
